import { Avatar } from "./avatar";
import { Gender } from "./common";

export type SparksNotificationProfileT = {
  uid: number;
  status: SparkNotificationStatus;
  updatedAt: number;
  profile: {
    uid: number;
    username: string;
    avatar: Avatar;
    gender: Gender;
    age?: number;
    online?: number;
  };
};

export type SparksStateT = {
  items: SparksNotificationProfileT[];
  hasUnviewed: boolean;
  uploaded: boolean;
  send: boolean;
  error: boolean;
};

export enum SparkNotificationStatus {
  NotViewed = 0,
  Viewed = 1,
}
